<script setup>
import { computed } from 'vue';
import RealEstateFinanceInstallmentCommissionSummary from './RealEstateFinanceInstallmentCommissionSummary.vue';
import RealEstateFinanceSaleSummary from './RealEstateFinanceSaleSummary.vue';
import RealEstateFinanceInstallmentSchedule from './RealEstateFinanceInstallmentSchedule.vue';

const props = defineProps({
  installment: { type: Object, default: null },
});

const emit = defineEmits([
  'download-sheet',
  'open-installment',
  'open-process',
]);
const detail = computed(() => props.installment || {});
const commission = computed(() => detail.value.comissao_geral || {});
const saleSummary = computed(() => detail.value.resumo_venda || {});
</script>

<template>
  <div class="grid gap-5 lg:grid-cols-2">
    <RealEstateFinanceSaleSummary
      :process="detail.dados_processo"
      :sale-summary="saleSummary"
      @details="emit('open-process', detail.dados_processo?.processo_id)"
    />

    <RealEstateFinanceInstallmentCommissionSummary
      :commission="commission"
      @details="emit('open-process', detail.dados_processo?.processo_id)"
    />
  </div>

  <RealEstateFinanceInstallmentSchedule
    class="mt-5"
    :current-installment-id="detail.parcela?.parcela_id"
    :installments="commission.parcelas"
    @download-sheet="emit('download-sheet', $event)"
    @open-installment="emit('open-installment', $event)"
  />
</template>
